import { SelectInput } from '@/components/form/fields/select/SelectInput';
import { SidebarMainSection } from '@/components/sidebar/SidebarMainSection';
import { getMspCatalogueLink } from '@/lib/getMyLinks';
import { useCompanies } from '@/services/api/hooks/companies';
import { RoleType, useRole } from '@/services/authentication/hooks/user';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import { CategoryLinks } from './CategoryLinks';

const CUSTOMER_LIST_OPTION_ID = 'customerList';

export const MspLinks: FC<{
  partnerId: string;
  selectedCustomerId: string;
  onSelectCustomerId: (newVal: string) => void;
}> = ({ partnerId, selectedCustomerId, onSelectCustomerId }) => {
  const [customers] = useCompanies(partnerId);

  const options = [
    {
      id: CUSTOMER_LIST_OPTION_ID,
      name: 'Manage Customers'
    },
    ...customers.map(c => ({
      name: c.name,
      id: c.id
    }))
  ];

  const navigate = useNavigate();

  const role = useRole();
  const catalogueLink = getMspCatalogueLink(partnerId);

  return (
    <>
      {role.type === RoleType.Admin && (
        <CategoryLinks
          baseId="mspCatalogue"
          baseUrl={`${catalogueLink}`}
          mainSection
          catalogueTitleOverride="MSP Catalogue"
        />
      )}
      <SidebarMainSection
        sectionUrlIdentifier="companiesList"
        title={'Customers'}
        to={`/msps/${partnerId}/companies/companiesList`}
      >
        {options.length > 0 && (
          <SelectInput
            id={'selectedCustomer'}
            value={options.find(o => o.id === selectedCustomerId) || null}
            placeholder={'Please Select'}
            onChange={option => {
              if (option && option.id === CUSTOMER_LIST_OPTION_ID) {
                navigate(`/msps/${partnerId}/companies/companiesList`);
                return;
              }

              onSelectCustomerId(option?.id || '');
              option && navigate(`/msps/${partnerId}/companies/${option.id}/catalogue`);
            }}
            options={options}
          />
        )}
      </SidebarMainSection>
    </>
  );
};
